:host {
  --icon-width: theme('width.6');
  --icon-height: theme('height.6');
  --icon-color: inherit;
  @apply inline-block align-middle relative text-left opacity-0 w-fit;
  transition: opacity 500ms ease-in;
  clip-rule: evenodd;
  fill: none;
  fill-rule: evenodd;
  line-height: 0;
}
@media (prefers-reduced-motion) {
  :host {
    transition: none;
  }

  .notifications::after {
    transition: none;
  }
}

:host(.loaded) {
  @apply opacity-100;
}

.info {
  --icon-color: rgb(var(--text-color-info-base));
}

.positive {
  --icon-color: rgb(var(--text-color-positive-base));
}

.caution {
  --icon-color: rgb(var(--text-color-caution-base));
}

.negative {
  --icon-color: rgb(var(--text-color-negative-base));
}

.neutral {
  --icon-color: rgb(var(--text-color-neutral-base));
}

.neutral2 {
  --icon-color: rgb(var(--text-color-neutral2-base));
}

.neutral2-inverse {
  /* TODO: Needs new value from XDS */
  --icon-color: rgb(var(--text-color-inverse-base));
}

.neutral-inverse {
  --icon-color: rgb(var(--text-color-inverse-base));
}

.theme1 {
  --icon-color: rgb(var(--text-color-theme1-base));
}

@media (forced-colors: active) {
  .icon-inner svg {
    /* stylelint-disable-next-line value-keyword-case */
    --icon-color: CanvasText;
  }
}

.icon-inner {
  @apply inline-block;
}

.icon-inner svg {
  color: var(--icon-color);
}

.size-xs {
  --icon-width: theme('width.4');
  --icon-height: theme('height.4');
}

.size-sm {
  --icon-width: theme('width.6');
  --icon-height: theme('height.6');
}

.size-md {
  --icon-width: theme('width.8');
  --icon-height: theme('height.8');
}

.size-lg {
  --icon-width: theme('width.12');
  --icon-height: theme('height.12');
}

.size-xl {
  --icon-width: theme('width.18');
  --icon-height: theme('height.18');
}

.size-xxl {
  --icon-width: theme('width.24');
  --icon-height: theme('height.24');
}

.icon,
.size-custom {
  width: var(--icon-width);
  height: var(--icon-height);
}

.notifications {
  @apply relative;
}

.notifications::after {
  content: '';
  @apply absolute block border-stroke-inverse-base border-solid rounded-full -right-0.5 -bottom-0.5;
  transition: background-color 200ms ease-in;
}
/* Dot Size */
.size-xs::after {
  @apply w-1.5 h-1.5 right-0 bottom-0;
  border-width: 0.0313rem;
}

.size-sm::after {
  @apply w-2 h-2 border right-0 bottom-0;
}

.size-md::after {
  @apply w-3 h-3;
  border-width: 0.0938rem;
}

.size-lg::after {
  @apply w-4 h-4 border-2;
}

.size-xl::after {
  border-width: 0.1875rem;
  @apply w-6 h-6;
}
/* Dot Status Color */
.notifications.dot-neutral::after {
  @apply bg-fill-neutral-base;
}

.notifications.dot-neutral2::after {
  @apply bg-fill-neutral2-base;
}

.notifications.dot-positive::after {
  @apply bg-fill-positive-base;
}

.notifications.dot-negative::after {
  @apply bg-fill-negative-base;
}

.notifications.dot-theme1::after {
  @apply bg-fill-theme1-base;
}

.notifications.dot-theme2::after {
  @apply bg-fill-theme2-base;
}

.notifications.dot-info::after {
  @apply bg-fill-info-base;
}

.notifications.dot-caution::after {
  @apply bg-fill-caution-base;
}
/* Priority */

.secondary {
  @apply alpha-secondary;
}

.tertiary {
  @apply alpha-tertiary;
}

.inactive {
  @apply alpha-inactive;
}
/* Contained */
.contained {
  /* TODO: Require new radius tokens from XDS */
  border-radius: 2.5rem;
}
/* Contained | Outline Display */
.contained.outline {
  @apply border border-solid;
}

.contained.outline.caution {
  @apply border-stroke-caution-base border-alpha-tertiary;
}

.contained.outline.info {
  @apply border-stroke-info-base border-alpha-tertiary;
}

.contained.outline.negative {
  @apply border-stroke-negative-base border-alpha-tertiary;
}

.contained.outline.neutral {
  @apply border-stroke-neutral-base border-alpha-tertiary;
}

.contained.outline.neutral-inverse {
  @apply border-stroke-inverse-base border-alpha-tertiary;
}

.contained.outline.neutral2 {
  @apply border-stroke-neutral2-base border-alpha-tertiary;
}

.contained.outline.neutral2-inverse {
  @apply border-stroke-inverse-base border-alpha-tertiary;
}

.contained.outline.positive {
  @apply border-stroke-positive-base border-alpha-tertiary;
}

.contained.outline.theme1 {
  @apply border-stroke-theme1-base border-alpha-tertiary;
}
/* Maps to Caution, Theme 2 Will Be Removed in 8.0 */
.contained.outline.theme2 {
  @apply border-stroke-caution-base border-alpha-tertiary;
}
/* Contained | Fill Display Tones | Priority */
.contained.fill.low.caution {
  @apply bg-material-caution-base;
}

.contained.fill.low.info {
  @apply bg-material-info-base;
}

.contained.fill.low.negative {
  @apply bg-material-negative-base;
}

.contained.fill.low.neutral {
  @apply bg-material-neutral-base;
}

.contained.fill.low.neutral-inverse {
  @apply bg-material-neutral-inverse-base;
}

.contained.fill.low.neutral2 {
  @apply bg-material-neutral2-base;
}

.contained.fill.low.neutral2-inverse {
  @apply bg-material-neutral2-inverse-base;
}

.contained.fill.low.positive {
  @apply bg-material-positive-base;
}

.contained.fill.low.theme1 {
  @apply bg-material-theme1-base;
}
/* Maps to Caution, Theme 2 Will Be Removed in 8.0 */
.contained.fill.low.theme2 {
  @apply bg-material-caution-base;
}
/* Contained | Fill Display Tones | Priority */
.contained.fill.high.caution {
  @apply bg-fill-caution-base;
}

.contained.fill.high.info {
  @apply bg-fill-info-base;
}

.contained.fill.high.negative {
  @apply bg-fill-negative-base;
}

.contained.fill.high.neutral {
  @apply bg-fill-neutral-base;
}

.contained.fill.high.neutral-inverse {
  @apply bg-fill-inverse-base;
}

.contained.fill.high.neutral2 {
  @apply bg-fill-neutral2-base;
}

.contained.fill.high.neutral2-inverse {
  @apply bg-fill-inverse-base;
}

.contained.fill.high.positive {
  @apply bg-fill-positive-base;
}

.contained.fill.high.theme1 {
  @apply bg-fill-theme1-base;
}
/* Maps to Caution, Theme 2 Will Be Removed in 8.0 */
.contained.fill.high.theme2 {
  @apply bg-fill-caution-base;
}
/* 16 */
.xs.contained {
  @apply py-1 px-1.5;
}
/* 24 */
.sm.contained {
  @apply py-2 px-3;
}
/* 32 */
.md.contained {
  @apply py-3 px-4;
}
/* 48 */
.lg.contained {
  @apply py-4 px-6;
}
/* 72 */
.xl.contained {
  @apply py-5 px-7;
  /* TODO: Require new radius tokens from XDS */
  border-radius: 3.75rem;
}
/* 96 */
.xxl.contained {
  @apply py-6 px-8;
  /* TODO: Require new radius tokens from XDS */
  border-radius: 5rem;
}
